import { format } from "date-fns";
import { Timestamp } from "firebase/firestore";

export class DateTimeField {
  public static fromFirestore(value: unknown): Date | undefined {
    if (value === null || value === undefined) return undefined;
    return (value as Timestamp).toDate();
  }

  public static toFirestore(value: Date | undefined): Timestamp | null {
    if (value === null || value === undefined) return null;

    return Timestamp.fromDate(value);
  }

  public static fromOfflineCache(value: unknown): Date | undefined {
    if (value === null || value === undefined) return undefined;
    return new Date(value as string);
  }

  public static toOfflineCache(value: Date | undefined): string | null {
    if (value === null || value === undefined) return null;

    return value.toISOString();
  }

  public static toStringValue(value: Date | undefined, defaultValue: string, dateFormat = "yyyy-MM-dd"): string {
    if (value === null || value === undefined) return defaultValue;

    return format(value, dateFormat);
  }
}
